import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

const IntroTime = () => {

   return (
      <IntroTimeStyles id="timetable">
         <h3>授業時間割</h3>
         <table className="time-table">
            <tbody>
               <tr>
                  <td>1限</td>
                  <td>09:30 - 11:00</td>
               </tr>
               <tr>
                  <td>2限</td>
                  <td>11:10 - 12:40</td>
               </tr>
               <tr>
                  <td>3限</td>
                  <td>13:20 - 14:50</td>
               </tr>
               <tr>
                  <td>4限</td>
                  <td>15:00 - 16:30</td>
               </tr>
               <tr>
                  <td>5限</td>
                  <td>16:50 - 18:20</td>
               </tr>
               <tr>
                  <td>6限</td>
                  <td>18:40 - 20:10</td>
               </tr>
               <tr>
                  <td>7限</td>
                  <td>20:20 - 21:50</td>
               </tr>
            </tbody>
         </table>
         
         <p>
            ※1～3限は土曜日・季節ごとの講習時のみ<br/>
            ※土曜日は6限までとなります
         </p>
      </IntroTimeStyles>
   )
}

const IntroTimeStyles = styled.section`
   width: 100%;
   color: #FF3D01;
   .time-table {
      margin: 40px auto 0;
      ${media.lessThan("600px")`
         margin-top: 24px;
      `}
      tbody {
         tr {
            td {
               font-size: 2.9rem;
               letter-spacing: 0.8rem;
               line-height: 3.5rem;
               ${media.lessThan("600px")`
                  font-size: 2.2rem;
                  letter-spacing: 0.1rem;
               `}
               &:first-child {
                  display: block;
                  margin-right: 30px;
               }
            }
         }
      }
   }

   p {
      margin-top: 40px;
      text-align: center;
      font-size: 2rem;
      line-height :3.4rem;
      color: #959595;
      ${media.lessThan("600px")`
         font-size: 1.6rem;
         margin-top: 20px;
         line-height: 2.2rem;
      `}
   }
`

export default IntroTime

